import { useCallback, useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Trans } from '@lingui/macro'
import {
  Alert
  , Box
  , Divider
  , Typography
  , useTheme
} from '@mui/material/'
import useHttp from '../hooks/useHttp'
import useLogout from '../hooks/useLogout'
import MobileTopNav, { MobileTopNavSpacer } from '../components/mobile/MobileTopNav'
import MobileBottomNav, { MobileBottomNavSpacer } from '../components/mobile/MobileBottomNav'
import DesktopNav from '../components/desktop/DesktopNav'
import UserForm from '../components/forms/UserForm'
import FullPageProgress from '../components/FullPageProgress'
import { ThemeContext } from '../App'
import { NewApiBaseUrl } from "../consts/new-api-base-url";
import useHttpApiNew from "../hooks/useHttpApiNew";
import DesktopToolbar from "../components/desktop/DesktopToolbar";
import { NAV_LAYOUT_MARGIN_START } from '../consts/nav-layout-margin'
import LayoutModeSwitch from '../components/layout-mode-switch'

/*
Fields editable by user:
- name
- surname
- department
- password
*/

// eslint-disable-next-line no-restricted-globals
// const userUrl = new URL('/api/user', location)
const getSingleUserUrl = new URL(`${NewApiBaseUrl}/Auth/Get`)

export default function User({ position, isMobile }) {
  const location = useLocation()
  const logout = useLogout()
  const persistedSession = useMemo(() => {
    try {
      const raw = localStorage.getItem('adams_user')
      const u = raw ? JSON.parse(raw) : null
      return {
        token: u?.token || localStorage.getItem('token') || null,
        user: u?.init?.user || null
      }
    } catch {
      return {
        token: localStorage.getItem('token') || null,
        user: null
      }
    }
  }, [])
  const token = location.state?.token || persistedSession.token
  const user = location.state?.init?.user || persistedSession.user
  const theme = useTheme()
  const { isLoading, error } = useHttp()
  const [userData, setUserData] = useState({})
  const { request } = useHttpApiNew()
  const isDark = theme.palette.mode === "dark";

  const getUser = useCallback(async () => {
    if (!user?.id) return
    /*
    sendRequest({
      token
      , url           : userUrl
      , manageResData : res => {
        setUserData(res.user)
      }
    })
     */
    const response = await request(getSingleUserUrl + `/${user.id}`, 'GET')
    if (response.responseAnyError) return;
    setUserData(response.responseData)
  }, [token, user?.id, request])

  useEffect(() => {
    if (!token) return logout()
    if (!user?.id) return
    getUser()
  }, [getUser, token, logout, user?.id])

  return (
    <Box
      component="main"
      sx={isMobile ? {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100dvh',
        maxHeight: '100dvh',
        overflow: 'hidden',
      } : {}}
    >
      {isMobile
        ? <>
          <MobileTopNav token={token} user={user} />
          <MobileTopNavSpacer />
        </>
        : <>
          <DesktopNav position={position} subPanelElements={[]} />
          <DesktopToolbar />
        </>
      }
      <Box
        display='flex'
        flexDirection='column'
        alignItems='center'
        width='100%'
        sx={isMobile ? {
          flex: 1,
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
        } : {
          paddingInlineStart: NAV_LAYOUT_MARGIN_START,
        }}
      >
        <Typography
          sx={isMobile ? { mt: 2, mb: 1, color:isDark ? 'white' : theme.palette.newColors.gray } : { mt: 2, mb: 2.5, color: isDark ? 'white' : theme.palette.newColors.gray }}
          variant={isMobile ? 'h4' : 'h3'}
          align='center'
        >
          <Trans>My Profile</Trans>
        </Typography>
        <Divider flexItem variant='middle' />
        <Box sx={{ mt: 2, mb: 1 }}>
          <LayoutModeSwitch />
        </Box>
        <Box
          width={isMobile ? '90%' : '80%'}
          maxWidth='sm'
        >
          <UserForm isMobile={isMobile} token={token} user={userData} />
        </Box>
        {error && <Alert sx={{ mt: 2 }} severity="error">
          <Trans>There was an error: {error}.</Trans>
        </Alert>}
        {isMobile && <MobileBottomNavSpacer />}
        <FullPageProgress isOpen={isLoading} isMobile={isMobile} />
      </Box>
      {isMobile && <MobileBottomNav />}
    </Box>
  )
}
